<template>
  <el-drawer
		@open="onShowDetail"
    :visible.sync="visible"
    :title="title"
    >
    <div>
      <div style="min-height: 82vh;">
				<template v-if="title === '店铺名称'">
					<el-row style="margin-bottom: 10px">
						<el-col :span="4">平台:</el-col>
						<el-col :span="20">
							<el-select
								style="width: 100%"
								size="small"
								clearable
								multiple
								v-model="selectPlat"
								@change="onSelectChange"
								placeholder="全部">
								<el-option
									v-for="item in plateList"
									:key="item.id"
									:value="item.dictName"
									:label="item.dictName"
								>
								</el-option>
							</el-select>
						</el-col>
					</el-row>
					<el-row style="margin-bottom: 10px">
						<el-col :span="4">店铺:</el-col>
						<el-col :span="20">
							<el-input
								v-model="selectShop"
								size="small"
								@input="onShopnameChange">
							</el-input>
						</el-col>
					</el-row>
				</template>
        <el-checkbox-group v-model="checkList" @change="handleCheckedGroupChange">
          <el-row>
            <el-col
              style="margin-bottom: 10px"
              v-for="item in (title === '店铺名称' ? shopData : data)"
              :key="item.id"
              :span="12"
              class="g-ellipsis"
            >
              <el-checkbox
                :disabled="selectIds && isTotalOptions ?
								selectIds.split(',').includes(item.id) && item.isChecked :
								selectIds ? !selectIds.split(',').includes(item.id) && item.isChecked
								: item.isChecked"
                :label="item.id"
              >{{ item.name }}
              </el-checkbox>
            </el-col>
          </el-row>
        </el-checkbox-group>
      </div>
      <div class="approval-way-box-footer">
        <div class="approval-way-box-footer-all">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
        </div>
        <div class="approval-way-box-footer-btn">
          <el-button size="small" class="g-confirm-btn" @click="handleCommitData">确定</el-button>
          <el-button size="small" class="g-cancel-btn" @click="handleClose">取消</el-button>
        </div>
      </div>
    </div>
    <div slot="reference">
      <slot name="options"></slot>
    </div>
  </el-drawer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'approvalOptions',

  components:{},

  props: {
    title: {
      type: String,
      required: true
    },
    data: {
      required: true,
      type: Array
		},
		selectIds: {
			type: String,
			default: ''
		},
		isTotalOptions: {
			type: Boolean,
      required: false
		},
  },

  data () {
    return {
			shopData: [],
			selectShop: '',
			selectPlat: [],
      visible: false,
      checkList: [],
      checkAll: false,
      isIndeterminate: true,
    }
  },

  methods: {
    drawShow() {
      this.visible = true
    },
		onShopnameChange(val) {
			this.shopData = this.data.filter(item => {
				return item.name.indexOf(val) !== -1
			})
		},
		onSelectChange(val) {
			if(!val.length) {
				this.shopData = this.data;
				return;
			}
			this.shopData = this.data.filter(item => {
				const plat = item.name.match(/\(\S+\)/)[0].slice(1, -1)
				return this.selectPlat.includes(plat)
			})
		},
		onShowDetail() {
			if(this.selectIds && !this.isTotalOptions) {
				const selectArr = this.selectIds.split(',');
				this.checkList = selectArr;
			}

			if(this.title === '店铺名称' && !this.plateList.length) {
				this.reqPlateList();
			}
			if(!this.shopData.length) {
				this.shopData = [...this.data];
			}
			if(this.isTotalOptions) {
				this.handleShopData()
			}
		},
		handleShopData() {
			this.shopData = this.shopData.map(shopItem => {
				const item = this.data.find(item => item.id === shopItem.id);
				shopItem.isChecked = item.isChecked;
				return shopItem;
			})
		},
    handleClose() {
      this.visible = false;
    },
    // 提交数据
    handleCommitData() {
      this.$emit('on-commit', {
        id: this.checkList,
        cb: () => {
          this.visible = false
        }
      });
      this.checkList = [];
    },
    // 监听全选状态改变
    handleCheckAllChange(val) {
      this.checkList = val ? this.allCheckId : [];
      this.isIndeterminate = false;
    },
    // 监听复选框状态改变
    handleCheckedGroupChange(value) {
			let checkedCount = value.length;
			this.checkAll = checkedCount === this.handleFilterData().length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.handleFilterData().length;
    },
    handleFilterData() {
      return (this.title === '店铺名称' ? this.shopData : this.data).filter(item => {
        return item.isChecked == false;
      })
		},
		...mapActions([
			'reqPlateList'
		])
  },

  computed: {
    allCheckId() {
      let res = [];
      for (let item of (this.title === '店铺名称' ? this.shopData : this.data)) {
        if(!item.isChecked) {
          res.push(item.id)
        }
      }
      return res;
		},
		...mapGetters([
			'plateList'
		]),
  },

  created() {

	},

  mounted() {
		console.log(this.title);


	},
}
</script>

<style lang='scss'>
.popper {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.approval-way-box-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  .approval-way-box-footer-all {
    margin-left: 20px;
  }

  .approval-way-box-footer-btn {
    margin-right: 20px;
  }
}

.approval-way-box-header {
  display: flex;
  align-items: center;
  width: 100%;
  height: 28px;
  background-color: #d9d9d9;
}

.approval-way-box {
  overflow-y: auto;
  max-height: 600px;
  min-width: 400px;
  max-width: 600px;
  background-color: #fff;
  border: solid 1px #d9d9d9;
  margin: -12px;
}

.g-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

</style>
